import { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, CITIES, SEO_CITIES, citySlug } from "@/lib/api";
import { HostessCard } from "@/components/HostessCard";
import { Seo } from "@/components/Seo";

const PAGE_CITIES = [...new Set([...SEO_CITIES, ...CITIES])];
const NEAREST = { Varese: "Milano" };

export default function CityPage() {
  const { slug } = useParams();
  const city = PAGE_CITIES.find((c) => citySlug(c) === slug);
  const searchCity = NEAREST[city] || city;
  const [list, setList] = useState(null);

  useEffect(() => {
    if (city) api.get("/hostesses", { params: { city: searchCity } }).then((r) => setList(r.data));
  }, [city, searchCity]);

  if (!city) return <Navigate to="/cerca" replace />;
  const area = searchCity === city ? city : `${searchCity} e provincia di ${city}`;

  return (
    <main className="max-w-7xl mx-auto px-6 lg:px-10 pt-16" data-testid="city-page">
      <Seo title={`Hostess, wingwoman e accompagnatrici a ${city} | YourHostess`}
        description={`Trova hostess, wingwoman e accompagnatrici a ${city} per eventi, fiere, cene e serate. Profili verificati: pubblica il tuo annuncio su YourHostess e ricevi subito i contatti.`} />
      <p className="eyebrow">{city}</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-3" data-testid="city-page-title">Hostess, wingwoman e accompagnatrici a {city}</h1>
      <p className="text-neutral-400 mt-6 max-w-2xl leading-relaxed" data-testid="city-page-intro">
        Cerchi una hostess per un evento, una fiera o un congresso a {city}? Oppure una wingwoman o un'accompagnatrice elegante per una cena o una serata?
        Su YourHostess trovi profili verificati di hostess e modelle a {area}: sfoglia le gallerie oppure pubblica il tuo annuncio e ricevi i contatti.
      </p>
      <div className="mt-8 flex flex-wrap gap-6">
        <Link to={`/cerca?city=${searchCity}`} className="btn-gold" data-testid="city-page-search-link">Vedi tutti i profili</Link>
        <Link to="/accedi?mode=register&role=client" className="text-xs uppercase tracking-[0.18em] text-neutral-300 hover:text-[#D4AF37] flex items-center gap-2" data-testid="city-page-event-link">Pubblica un annuncio <ArrowRight className="w-3 h-3" /></Link>
      </div>
      <p className="mt-16 mb-6 text-xs font-mono text-neutral-500" data-testid="city-page-count">{list ? `${list.length} ${list.length === 1 ? "profilo" : "profili"} a ${area}` : "Caricamento…"}</p>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6" data-testid="city-page-grid">
        {(list || []).slice(0, 12).map((h, i) => <HostessCard key={h.id} h={h} index={i} />)}
      </div>
      <nav className="mt-20 pt-8 border-t border-white/5 flex flex-wrap gap-x-6 gap-y-2 text-xs text-neutral-500" data-testid="city-page-other-cities">
        <span className="eyebrow !text-neutral-500">Altre città</span>
        {PAGE_CITIES.filter((c) => c !== city).map((c) => <Link key={c} to={`/hostess-a/${citySlug(c)}`} className="hover:text-[#D4AF37]" data-testid={`city-link-${citySlug(c)}`}>Hostess a {c}</Link>)}
      </nav>
    </main>
  );
}
